import React from 'react';
export function EventIntro() {
  return <section aria-labelledby="event-details" className="mx-auto max-w-3xl px-6 text-center" data-id="element-2" data-mp="tuutsgmtczzn">
      <h2 id="event-details" className="sr-only" data-id="element-3" data-mp="2kf6jrqjgk8r2">
        Fecha y descripción del evento
      </h2>

      <div className="inline-flex flex-col items-center gap-0.5 rounded-lg border border-violet-glow/40 bg-white/[0.03] px-4 py-2.5 shadow-[0_0_40px_-18px_rgba(168,85,247,0.8)] sm:gap-1 sm:rounded-xl sm:px-6 sm:py-4" data-id="element-4" data-mp="2yeoaibgbdw32">
        <p className="font-display text-sm font-bold uppercase tracking-[0.14em] text-white sm:text-xl sm:tracking-[0.18em]" data-id="element-5" data-mp="37bou84sfv606">
          Martes 22 de septiembre
        </p>
        <p className="font-display text-[0.6875rem] font-semibold uppercase tracking-[0.22em] text-violet-300 sm:text-sm sm:tracking-[0.3em]" data-id="element-6" data-mp="3h3csaoji3lam">
          10:00 a.&nbsp;m. – 4:00 p.&nbsp;m.
        </p>
      </div>

      <p className="mx-auto mt-8 hidden max-w-2xl text-base leading-relaxed text-slate-300 sm:block sm:text-lg" data-id="element-7" data-mp="3r2ac5e5zeqna">
        Una jornada para fortalecer tus habilidades, desarrollar tu equipo y llevar tu negocio al
        siguiente nivel.
      </p>
    </section>;
}